/*
 * Copyright (c) 2023 Potentially Ltd
 *
 * Please see distribution for license
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arraySort',
})
export class ArraySortPipe implements PipeTransform {
  /**
   *
   * @param value Value to be transformed
   * @param sortType Value to determine sorting way
   * @param sortableKey Property name used to sort array if the array is object array
   * @param length Length to get first some elements from sorted array
   * @returns Array
   */
  transform(value: unknown[], sortType: 'asc' | 'desc', sortableKey: string, length: number): unknown[] {
    if (!value || value.length === 0) return [];

    const sortNumber = sortType === 'asc' ? 1 : -1;

    if (sortableKey) {
      value.sort((a, b) => {
        return !isNaN(Date.parse(value[0][sortableKey]))
          ? this.sortDateTime(a[sortableKey], b[sortableKey]) * sortNumber
          : this.sortString(a[sortableKey], b[sortableKey]) * sortNumber;
      });
    } else {
      value.sort();
    }

    return value.slice(0, length);
  }

  private sortDateTime(a, b): number {
    return +new Date(a) - +new Date(b);
  }

  private sortString(a, b): number {
    if (a < b) {
      return -1;
    }
    if (a < b) {
      return 1;
    }
    return 0;
  }
}
